import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const GroupContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    height: 100%;
    z-index: 9;
    border-radius: 0;
    margin: 0;
    padding: 0;
    height: 100vh;
    overflow: scroll;
    background-color: ${({ theme }) => theme.airlinesList.background};
  }
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
`;

export const ListContainer = styled.div`
  flex: 1;
`;

export const List = styled.ul``;
